import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Propeller = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.728 18.304C25.904 17.564 26 16.793 26 16C26 10.486 21.514 6 16 6C15.207 6 14.436 6.096 13.696 6.272C11.682 3.675 8.533 2 5 2C3.346 2 2 3.346 2 5C2 8.533 3.675 11.682 6.272 13.696C6.096 14.436 6 15.207 6 16C6 21.514 10.486 26 16 26C16.793 26 17.564 25.904 18.304 25.728C20.318 28.325 23.467 30 27 30C28.654 30 30 28.654 30 27C30 23.467 28.325 20.318 25.728 18.304V18.304ZM16 8C20.411 8 24 11.589 24 16C24 16.394 23.97 16.782 23.914 17.161C22.716 16.56 21.395 16.173 19.999 16.046C19.999 16.031 20 16.016 20 16C20 13.794 18.206 12 16 12C15.985 12 15.97 12.001 15.954 12.001C15.828 10.605 15.44 9.283 14.839 8.086C15.218 8.03 15.605 8 16 8V8ZM16 14C17.103 14 18 14.897 18 16C18 17.103 17.103 18 16 18C14.897 18 14 17.103 14 16C14 14.897 14.897 14 16 14ZM4 5C4 4.449 4.449 4 5 4C9.81 4 13.751 7.793 13.989 12.545C13.392 12.894 12.894 13.392 12.545 13.989C7.793 13.751 4 9.811 4 5.001V5ZM16 24C11.589 24 8 20.411 8 16C8 15.606 8.03 15.218 8.086 14.839C9.283 15.44 10.605 15.828 12.001 15.954C12.001 15.969 12 15.984 12 16C12 18.206 13.794 20 16 20C16.015 20 16.03 19.999 16.046 19.999C16.172 21.395 16.56 22.717 17.161 23.914C16.782 23.97 16.395 24 16 24V24ZM27 28C22.19 28 18.249 24.207 18.011 19.455C18.608 19.106 19.106 18.608 19.455 18.011C24.207 18.249 28 22.189 28 26.999C28 27.55 27.551 27.999 27 27.999V28Z" />
	</svg>
);

export default Propeller;
